import React from 'react';
import '../style/CarCategoryCarousel.css';
import CarCarousel from './CarCarousel';
import { expectedCars, newlyLaunchedCars, popularCars } from '../data/carCategoryData';

const CarCategoryCarousel = () => {
  return (
    <div className="premium-stack-container">
      <div className="stack-row upcoming">
        <CarCarousel 
          title="Upcoming Cars" 
          subtitle="Be the first to drive the future"
          data={expectedCars} 
          type="upcoming"
        />
      </div>
      
      <div className="stack-row latest">
        <CarCarousel 
          title="Newly Launched" 
          subtitle="Fresh arrivals in the showroom"
          data={newlyLaunchedCars} 
          type="latest"
        />
      </div>

      <div className="stack-row electric">
        <CarCarousel 
          title="Popular Electric" 
          subtitle="Top-rated sustainable mobility"
          data={popularCars} 
          type="electric"
        />
      </div>
    </div>
  );
};

export default CarCategoryCarousel;